<template>
  <div class="container-fluid">
    <div class="row">
      <LayoutLeftAuth />

      <div class="col-md-5 ">
        <div class="container h-full d-flex align-items-center justify-content-center">
          <div class="row d-flex flex-column text-center align-items-center">
            <img src="../../assets/img/blue-logo.png" class="logo-mobile-auth d-block d-sm-none" />
            <div class="welcome-text">
              Welcome back!
            </div>
            <div class="under-welcome-text">
              Login to your dispatch application
            </div>
            <form @submit.prevent="login" @keydown="clearError($event)" autocomplete="no" class="new-auth-form">
              <div class="form-row">
                <div class="col-md-12 first-input">
                  <div class="material-textfield">
                    <input v-model="auth.email"
                           id="email"
                           name="email"
                           type="text"
                           placeholder=" "
                           autofocus
                    />
                    <label>Email</label>
                  </div>
                  <error-field :errors="errors" field="email" class="material-errors" />
                </div>
                <div class="col-12 second-input">
                  <div class="material-textfield">
                    <input v-model="auth.password"
                           id="password"
                           name="password"
                           type="password"
                           placeholder=" "
                    />
                    <label>Password</label>
                  </div>
                  <error-field :errors="errors" field="password" class="material-errors" />
                  <error-field :errors="errors" field="credentials" class="material-errors" />
                  <error-field :errors="errors" field="exception" class="material-errors" />
                  <div class="material-errors" v-if="userStatusError">Your account is inactive.</div>
                </div>
              </div>
              <input type="submit" class="btn btn-primary login-button hover-btn-bg"
                     value="Login"
                     :disabled="errors.any()"
              />
            </form>

            <router-link class="thick-font" to="forgot-password">Forgot password?</router-link>
            <div class="under-button-text">Don't have an account yet?</div>
            <button class="sign-up-btn" @click="$router.push('/register')"> Sign up</button>
            <a :href="getForemanUrl" target="_blank"><div class="foreman-retangle align-items-center d-md-none">
              <span class="d-flex justify-content-between align-items-center foreman-top">
                <div class="foreman-title-respo">Are you a foreman?</div>
                <div class="foreman-arrow-respo pointer"> <span class="thick-font changed-router-links"><i class="fa fa-long-arrow-right" /></span></div>
              </span>
              <div class="foreman-text-respo">We’re currently working on a native app for Android and iOS. For now you can login to your account and track moves on our web app.</div>
            </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutLeftAuth from './components/LayoutLeftAuth';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  components: {
    ErrorField,
    LayoutLeftAuth,
  },
  data: () => ({
    auth: {
      email: '',
      password: '',
    },
    errors: new Errors(),
    userStatusError: false,
  }),
  computed: {
    ...mapGetters({
      userData: 'userData',
    }),
    getForemanUrl() {
      if (process.env.NODE_ENV === 'develop') {
        return 'https://ma.24mod.com';
      }
      return 'https://movers.mod24.com';
    },
  },
  methods: {
    ...mapActions(['authLogin']),
    login() {
      this.userStatusError = false;
      this.authLogin({ ...this.auth })
        .then(() => {
          if (this.userData.user_status_id === 1) {
            this.$router.push('/');
          } else {
            this.userStatusError = true;
          }
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      // TODO: make error handling better
      if (this.errors.has('credentials')) {
        this.errors.clear('credentials');
      }
      if (this.errors.has('exception')) {
        this.errors.clear('exception');
      }
      this.errors.clear(event.target.name);
    },
  },
};
</script>
<style scoped>
.welcome-text {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: -0.72px;
  color: #131c36;
  margin-bottom: 7px;
}
.under-welcome-text {
  font-size: 18px;
  line-height: 24px;
  color: #3e475e;
  margin-bottom: 45px;
}
.first-input {
  margin-bottom: 18px;
}
.second-input {
  margin-bottom: 40px;
}
.login-button {
  margin-bottom: 10px;
  font-size: 16px;
  background: #2962ff;
  color: white;
  width: 318px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
}
.under-button-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #3e475e;
  margin-top: 60px;
  margin-bottom: 20px;
}
.sign-up-btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #2962ff;
  padding: 18px 0;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  width: 310px;
}
.sign-up-btn:hover {
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
}
.login-input {
  background: rgba(239, 239, 239, 0.2);
  border: 1px solid rgba(97, 97, 97, 0.1);
  border-radius: 3px;
  font-size: 16px;
  line-height: 20px;
  color: #616161;
}

.foreman-retangle {
  background: #2962ff;
  color: #fff;
  border-radius: 4px;
  padding: 20px;
  bottom: 40px;
  width: 100%;
  margin-top: 47px;
  text-align: justify;
  margin-bottom: 27px;
  max-width: 318px;
}
.foreman-top {
  margin-bottom: 27px;
}
.foreman-title-respo {
  font-size: 16px;
  line-height: 24px;
}
.foreman-arrow-respo a {
  color: white;
}
.foreman-text-respo {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.0875px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue